module.exports = __webpack_public_path__ + "img/image-empty-ubs.acb69377.svg";